import React from 'react';
import { CalendarAnnouncementView, ICalendarAnnouncementViewProps } from './CalendarAnnouncementView';
import { useUserStore } from '@gik/core/store/UserStore';
import { useInkindStore } from '@gik/inkind/store/InkindStore';
import { useInkind } from '@gik/api/inkinds/inkind';
import { canUserEditPage } from '@gik/inkind-page/utils/inkindPagePermissions';
import { renderPortal } from '@gik/core/utils/RenderPortal';
import { Button, SvgIcon } from '@gik/ui';
import { UIButtonVariant } from '@gik/ui/types';
import noop from '@gik/core/utils/noop';
import { translationKeys as commonTranslationKeys } from '@gik/i18n/en/common';
import { useTranslation } from 'react-i18next';

// import { deleteAnnouncement } from '@gik/calendar/utils/EventUtils';

export interface ICalendarAnnouncementViewWrapperProps extends ICalendarAnnouncementViewProps {
  buttonsPortal?: () => HTMLElement;
  typeContext: UIButtonVariant;
  entryId?: string; // only needed when delete buttons needs to be displayed
  onDone?(): void;
  onEdit?(): void;
  onDeleted?(): void;
}

export function CalendarAnnouncementViewWrapper({
  startsAt,
  typeContext,
  // entryId,
  buttonsPortal,
  onDone = noop,
  onEdit = noop,
  // onDeleted = noop,
  ...otherProps
}: ICalendarAnnouncementViewWrapperProps) {
  const { t } = useTranslation();

  const userId = useUserStore(state => state.id);
  const inkindRouteId = useInkindStore(state => state.inkindRouteId);
  const { data: inkind } = useInkind(inkindRouteId);
  const canEdit = canUserEditPage(inkind, userId);

  // const [deleting, setDeleting] = React.useState<boolean>(false);
  // const [errorMessage, setErrorMessage] = React.useState<string>();

  // async function handleDelete() {
  //   setDeleting(true);
  //   let response: boolean;
  //   try {
  //     response = await deleteAnnouncement(entryId, startsAt);
  //   } catch (err) {
  //     console.error(err);
  //     setErrorMessage(err.message);
  //     setDeleting(false);
  //     return;
  //   }

  //   setDeleting(false);
  //   if (response === false) return;
  //   onDeleted();
  // }

  const buttons = () => {
    if (canEdit) {
      return (
        <div className={'gik-form__actions-new'}>
          <section>
            {/* <Button variant="danger" onClick={handleDelete} loading={deleting} prepend={<SvgIcon name={'Trash'} />}>
              {t(commonTranslationKeys.delete)}
            </Button> */}
            <Button variant="secondary" onClick={onEdit} prepend={<SvgIcon name={'Pencil'} />}>
              {t(commonTranslationKeys.edit)}
            </Button>
          </section>
          <section>
            <Button onClick={onDone}>{t(commonTranslationKeys.done)}</Button>
          </section>
        </div>
      );
    }

    return (
      <Button wide variant={typeContext} onClick={onDone}>
        {t(commonTranslationKeys.done)}
      </Button>
    );
  };

  return (
    <>
      <CalendarAnnouncementView startsAt={startsAt} {...otherProps} />
      {/* <FormError centered message={errorMessage} /> */}
      {renderPortal(buttons(), buttonsPortal)}
    </>
  );
}
